import React, { useState } from 'react'
import tw from 'tailwind-styled-components';
import { FaArrowLeft, FaShoppingCart } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Set_Cart_Modal_Open } from '../Redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { useQuery } from "react-query";
import axios from "axios";
import Cart from '../components/Cart';
import Images from "../Images";
import Config from '../Config';
import EmailLoginModal from '../components/EmailLoginModal';
import LoginModal from '../Pages/User/Login';
import SignupModal from '../Pages/User/Register';
import CategoriesLoading from '../components/SkeletonLoading/CategoriesLoading';

const Categories = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.UserReducer.user);
    const isCartModalOpen = useSelector((state) => state.CartReducer.isCartModalOpen);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [isOTPLoginModalOpen, setIsOTPLoginModalOpen] = useState(false);
    const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);

    const handleOpenCartModal = () => {
        if (user) dispatch(Set_Cart_Modal_Open(true));
        else setIsLoginModalOpen(true);
    };

    const handleCloseCartModal = () => {
        dispatch(Set_Cart_Modal_Open(false));
    };

    const handleCategoryClick = (category) => {
        navigate(`/products/all-products`, {
            state: { categoryId: category.id, sectionTitle: category.name }
        });
    };

    // Fetch categories data
    const fetchCategory = async () => {
        return await axios.get(`${Config.apiUrl}/categories`);
    };

    const { isLoading: Loading, error: Error, data: categoryResponse } = useQuery(
        "fetchCategory",
        fetchCategory
    );

    const processCategories = (data) => {
        if (!data || data.length === 0) return [];
        return data
            .filter(category => category.is_active)
            .sort((a, b) => a.sort_order - b.sort_order);
    };

    const categoriesData = categoryResponse?.data?.data?.categories || [];
    const activeCategories = processCategories(categoriesData);
    // Dynamic grouping
    const firstSection = activeCategories.slice(0, 4); // first 4 categories
    const secondSection = activeCategories.slice(4, 12); // next 8 categories

    if (Loading) {
        return (
            <PageContainer>
                <TopNavbar>
                    <BackButton onClick={() => navigate(-1)}><FaArrowLeft className="w-6 h-6" /></BackButton>
                    <PageTitle>Shop by Category</PageTitle>
                    <CartButton onClick={handleOpenCartModal}><FaShoppingCart className="w-6 h-6" /></CartButton>
                </TopNavbar>
                {/* <LoadingContainer><LoadingSpinner /></LoadingContainer> */}
                <CategoriesLoading />
            </PageContainer>
        );
    }

    if (Error) {
        return (
            <PageContainer>
                <TopNavbar>
                    <BackButton onClick={() => navigate(-1)}>
                        <FaArrowLeft className="w-6 h-6" />
                    </BackButton>
                    <PageTitle>Shop by Category</PageTitle>
                    <CartButton onClick={handleOpenCartModal}>
                        <FaShoppingCart className="w-6 h-6" />
                    </CartButton>
                </TopNavbar>
                <ErrorContainer>
                    <ErrorText>Failed to load categories. Please try again.</ErrorText>
                </ErrorContainer>
            </PageContainer>
        );
    }

    return (
        <PageContainer>
            <TopNavbar>
                <BackButton onClick={() => navigate(-1)}><FaArrowLeft className="w-6 h-6" /></BackButton>
                <PageTitle>Shop by Category</PageTitle>
                <CartButton onClick={handleOpenCartModal}><FaShoppingCart className="w-6 h-6" /></CartButton>
            </TopNavbar>

            <SectionWrapper>
                <SectionTitle>Daily & Lifestyle Essentials</SectionTitle>
                <ItemsGrid>
                       {firstSection.map((category) => (
                            <CategoryItem key={category.id} onClick={() => handleCategoryClick(category)}>
                                <img
                                    src={category.image || Images.smartphones}
                                    alt={category.name}
                                    className="h-32 w-32 aspect-square object-contain"
                                />
                                <span>{category.name}</span>
                            </CategoryItem>
                        ))}
                </ItemsGrid>
                {/* <ViewAllButton>View all</ViewAllButton> */}
            </SectionWrapper>

            <SectionWrapper>
                <SectionTitle>Featured Collections</SectionTitle>
                <ItemsGrid>
                        {secondSection.map((category) => (
                            <CategoryItem key={category.id} onClick={() => handleCategoryClick(category)}>
                                <img
                                    src={category.image || Images.smartphones}
                                    alt={category.name}
                                    className="h-32 w-32 aspect-square object-contain"
                                />
                                <span>{category.name}</span>
                            </CategoryItem>
                        ))}
                </ItemsGrid>
            </SectionWrapper>

            <EmailLoginModal
                isOpen={isLoginModalOpen}
                onClose={() => setIsLoginModalOpen(false)}
                onSwitchToSignup={() => {
                    setIsLoginModalOpen(false);
                    setIsSignupModalOpen(true);
                }}
                onSwitchToEmailLogin={() => {
                    setIsLoginModalOpen(false);
                    setIsOTPLoginModalOpen(true);
                }}
            />
            <LoginModal
                isOpen={isOTPLoginModalOpen}
                onClose={() => setIsOTPLoginModalOpen(false)}
                onSwitchToSignup={() => {
                    setIsOTPLoginModalOpen(false);
                    setIsSignupModalOpen(true);
                }}
            />
            <SignupModal
                isOpen={isSignupModalOpen}
                onClose={() => setIsSignupModalOpen(false)}
                onSwitchToLogin={() => {
                    setIsSignupModalOpen(false);
                    setIsLoginModalOpen(true);
                }}
            />
            <Cart isOpen={isCartModalOpen} onClose={handleCloseCartModal} />
        </PageContainer>
    )
}

// Styled Components
const PageContainer = tw.div`min-h-screen w-full bg-white`;
const TopNavbar = tw.div`flex justify-between items-center p-3 md:p-2 bg-white border-b border-gray-200 sticky top-0 z-10`;
const BackButton = tw.button`text-gray-600 hover:text-gray-900 p-2 rounded-lg hover:bg-gray-100 transition-colors`;
const PageTitle = tw.h1`text-lg font-semibold text-gray-800 tracking-wider md:text-xl`;
const CartButton = tw.button`p-1 text-gray-600 hover:text-gray-800 transition-colors md:p-2`;
const SectionTitle = tw.h2`text-xl font-bold text-gray-800 my-2 md:my-3`;
const SectionWrapper = tw.div`p-4 pt-1 md:px-8`; 
const ItemsGrid = tw.div`grid grid-cols-2 md:grid-cols-4 gap-4 p-3 box-shadow-md scrollbar-hide border border-gray-300 md:border-0 rounded-lg`;
const CategoryItem = tw.div`flex flex-col items-center justify-center gap-2 p-1 cursor-pointer rounded-lg transition-colors`;
const ViewAllButton = tw.button`block mx-auto px-3 py-0.5 mb-2 text-kuality-blue rounded-md hover:text-kuality-dark transition-colors text-md font-medium`;
const LoadingContainer = tw.div`flex justify-center items-center py-12`;
const LoadingSpinner = tw.div`animate-spin rounded-full h-12 w-12 border-b-2 border-kuality-blue`;
const ErrorContainer = tw.div`flex justify-center items-center py-12`;
const ErrorText = tw.p`text-center text-red-500`;

export default Categories